import { CONTRACT_MODEL } from '@/helpers/constants'

const PT_ADDITIONAL_SERVICE_GROUPS = [
  {
    title: 'SERVIÇOS ADICIONAIS - TRANSVERSAIS',
    serviceIds: ['COB', 'BACK', 'DDA', 'FRAGIL', 'SE1000', 'SE2500', 'SE5000', 'SE7500', 'SE10000', 'SE12500'],
  },
  {
    title: 'SERVIÇOS ADICIONAIS - B2B',
    serviceIds: ['B2B.SMS', 'B2B.SABADO'],
  },
  {
    title: 'SERVIÇOS ADICIONAIS - B2C',
    serviceIds: [
      'PONTOCTT',
      '2TENTCTT',
      '2TENTDEV',
      'REC0810',
      'REC1013',
      'REC1316',
      'REC1619',
      'REC1922',
      'CONJUNTA',
      'MANHA',
      'TARDE',
      'NOITE',
      'SABADO',
      'ALTMANHA',
      'ALTTARDE',
      'ALTNOITE',
      'ALTDATA',
      'ALTDESTINO',
      'ALTORIGEM',
      'ALTPRAZO',
      'ALTM2M_MMR',
      'ALTM2P_MMR',
      'ALTP2M_MMR',
      'ALTP2P_MMR',
      'ALTM2M_OTR',
      'ALTM2P_OTR',
      'ALTP2M_OTR',
      'ALTP2P_OTR',
      'ALT0810',
      'ALT1013',
      'ALT1316',
      'ALT1619',
      'ALT1922',
      'ALTMOR_MR',
      'ALTMOR_OR',
    ],
  },
  {
    title: 'SERVIÇOS ADICIONAIS - CARGA',
    serviceIds: ['CARGA.COB', 'CARGA.DDA', 'CARGA.FRAGIL', 'CARGA.SEGURO'],
  },
  {
    title: 'TAXAS - B2C/B2B',
    serviceIds: [
      'TXENRGDISC',
      'TXRECNEFECT',
      'TXDISFORME',
      'TXDISFORMEDEV',
      'TXDUA',
      'TXREMESSA9+',
      'TXCEP.ENRGDISC',
      'TXCEP.RECNEFECT',
      'TXCEP.DISFORME',
      'TXCEP.DUA',
      'TXCEP.REMESSA9+',
    ],
  },
  {
    title: 'TAXAS - CARGA',
    serviceIds: ['TXCARGA.ENRGDISC', 'TXCARGA.DISFORME', 'TXCARGA.VOLNCINT', 'TXCARGA.MD3', 'TXCARGA.GRANDESUP'],
  },
]

const ES_2025_ADDITIONAL_SERVICE_GROUPS = [
  {
    title: 'SERVICIOS COMPLEMENTARIOS - GENERALES',
    serviceIds: [
      'SEG_DECLARADO',
      'REEMBOLSO',
      'KM_EXTRARADIO',
      'ENTREGA_SABADO',
      'SMS',
      'VALIDA_DNI',
      'ALB_ESCANEADO',
      'OTP',
      'GRANDES_SUPERFICIES',
    ],
  },
  {
    title: 'SERVICIOS ECOMMERCE',
    serviceIds: [
      'TARJETA_CTT',
      'DEV_AGRUPADA',
      'IMPRESION_DESTINO',
      'IMPRESION_ADIC',
      'PORTEO',
    ],
  },
  {
    title: 'SERVICIOS EXCEPCIONALES Y SUPLEMENTOS',
    serviceIds: [
      'EXCESO_PESO',
      'EXCESO_MEDIDA',
      'MERCANCIAS_PELIGROSAS',
      'FRAGILIDAD',
      'CAMBIO_SERVICIO',
    ],
  },
  {
    title: 'SERVICIOS CANARIAS',
    serviceIds: [
      'REEX_CAN_INTER',
      'REEX_CAN_KG',
      'REEX_CAN_INTER_48',
      'CAN_ECOMMERCE_ALTO_VALOR',
    ],
  },
]

const ADDITIONAL_SERVICE_GROUPS_BY_MODEL = {
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT]: PT_ADDITIONAL_SERVICE_GROUPS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT_NEXUS]: PT_ADDITIONAL_SERVICE_GROUPS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_PT_NEXUS]: PT_ADDITIONAL_SERVICE_GROUPS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025]: ES_2025_ADDITIONAL_SERVICE_GROUPS,
  [CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026]: ES_2025_ADDITIONAL_SERVICE_GROUPS,
}

const PT_DEFAULT_GROUP_TITLE = 'SERVIÇOS ADICIONAIS - OUTROS'
const ES_DEFAULT_GROUP_TITLE = 'SERVICIOS ADICIONALES - OTROS'
const FALLBACK_GROUP_TITLE = 'SERVICIOS ADICIONALES'

export const groupAdditionalServicesForExcel = (contractModel, services) => {
  if (!Array.isArray(services) || services.length === 0) {
    return []
  }

  const groupConfig = ADDITIONAL_SERVICE_GROUPS_BY_MODEL[contractModel]
  if (!groupConfig || groupConfig.length === 0) {
    return [
      {
        title: FALLBACK_GROUP_TITLE,
        services: [...services],
      },
    ]
  }

  const servicesById = new Map()
  services.forEach((service) => {
    if (service?.id) {
      servicesById.set(service.id, service)
    }
  })

  const remainingIds = new Set(servicesById.keys())
  const grouped = []

  groupConfig.forEach((group) => {
    const matched = []

    group.serviceIds.forEach((serviceId) => {
      if (remainingIds.has(serviceId)) {
        const service = servicesById.get(serviceId)
        if (service) {
          matched.push(service)
          remainingIds.delete(serviceId)
        }
      }
    })

    if (matched.length > 0) {
      grouped.push({
        title: group.title,
        services: matched,
      })
    }
  })

  if (remainingIds.size > 0) {
    const others = []
    remainingIds.forEach((serviceId) => {
      const service = servicesById.get(serviceId)
      if (service) {
        others.push(service)
      }
    })
    if (others.length > 0) {
      // Determinar el título del grupo "OTROS" según el modelo
      const isPortugalModel = contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT || 
                             contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT_NEXUS ||
                             contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_PT_NEXUS
      const defaultGroupTitle = isPortugalModel ? PT_DEFAULT_GROUP_TITLE : ES_DEFAULT_GROUP_TITLE
      
      grouped.push({
        title: defaultGroupTitle,
        services: others,
      })
    }
  }

  return grouped
}
